import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-foreground-900">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-background-50 mb-4">
            {t('categories_title')}
          </h2>
          <p className="text-base md:text-lg text-foreground-300 max-w-2xl">
            {t('categories_subtitle')}
          </p>
          <p className="mt-2 text-sm text-foreground-400 max-w-2xl">
            {t('categories_desc')}
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-100/10 rounded-lg overflow-hidden hover:bg-background-100/20 transition-all cursor-pointer"
            >
              {/* Image */}
              <div className="aspect-square overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name} - ${cat.namePl}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              {/* Label */}
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-background-50 mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-400">
                  {cat.desc}
                </p>
              </div>
            </a>
          ))}
        </div>

        {/* View All Button */}
        <div className="mt-10 text-center">
          <span className="inline-flex items-center gap-2 px-5 py-2.5 border border-background-50/30 text-background-50/80 text-sm font-medium rounded-full hover:border-background-50/60 hover:text-background-50 transition-all cursor-default">
            <i className="ri-apps-2-line"></i>
            14 {t('btn_all_categories').split(' ').pop()}
          </span>
        </div>
      </div>
    </section>
  );
}